import MetallicPillButton from '@/components/Base/MetallicPillButton';
import SurveyBackgroundLayout from '@/components/layout/SurveyBackgroundLayout';
import { SurveyBrownPanel } from '@/components/layout/SurveyBrownPanel';
import { useSurveyLanguage } from '@/hooks/useSurveyLanguage';
import { getTranslations } from '@/locales';
import type { SurveyLanguage } from '@shared/types/surveyLanguage';
import { useNavigate } from 'react-router-dom';

export default function Home() {
  const navigate = useNavigate();
  const { setSurveyLanguage } = useSurveyLanguage();

  const goAgeSmoker = (lang: SurveyLanguage) => {
    setSurveyLanguage(lang);
    navigate('/age_smoker');
  };

  // Home renders before a language is chosen — derive translations eagerly per button.
  const tEn = getTranslations('en').home;
  const tBm = getTranslations('bm').home;

  return (
    <SurveyBackgroundLayout>
      <div className="absolute z-10 left-9 right-9 top-[15%] flex flex-col items-start text-left">
        <h1 className="text-[36px] sm:text-[42px] font-semibold text-white tracking-tight drop-shadow-[0_2px_12px_rgba(0,0,0,0.45)] flex flex-col gap-1 sm:gap-1.5 text-left leading-tight">
          <span className="block">Welcome</span>
          <span className="flex flex-col gap-0 leading-none [&>span]:leading-none">
            <span className="block">Selamat</span>
            <span className="block -mt-[0.12em]">Datang</span>
          </span>
          <span className="block">欢迎</span>
        </h1>
      </div>

      {/* Panel + language buttons — column starts at 45% from top */}
      <div className="absolute z-10 inset-x-0 top-[45%] flex flex-col items-stretch gap-10 px-9">
        <SurveyBrownPanel>
          {/*
            Join line fragments into flowing paragraphs. Forced <br /> plus a narrow
            phone panel caused orphan words ("the", "token") and large visual gaps.
          */}
          <p className="m-0">
            {[tEn.brownLine1, tEn.brownLine2, tEn.brownLine3].filter(Boolean).join(' ')}
          </p>
          <p className="mt-[1lh] m-0">
            {[tEn.brownLine4, tEn.brownLine5, tEn.brownLine6].filter(Boolean).join(' ')}
          </p>
          {/* BM block — only shown when BM strings are provided */}
          {(tBm.brownLine1 !== tEn.brownLine1 || tBm.brownLine4 !== tEn.brownLine4) && (
            <>
              <p className="mt-[1lh] m-0">
                {[tBm.brownLine1, tBm.brownLine2, tBm.brownLine3].filter(Boolean).join(' ')}
              </p>
              <p className="mt-[1lh] m-0">
                {[tBm.brownLine4, tBm.brownLine5, tBm.brownLine6].filter(Boolean).join(' ')}
              </p>
            </>
          )}
        </SurveyBrownPanel>
        {/* Full content width: cancel px-9 so justify-evenly uses the phone shell width */}
        <div className="-mx-9 flex flex-nowrap items-center justify-evenly px-6">
          <MetallicPillButton
            size="sm"
            type="button"
            className="metallic-pill--lang-home"
            onClick={() => goAgeSmoker('en')}
          >
            EN
          </MetallicPillButton>
          <MetallicPillButton
            size="sm"
            type="button"
            className="metallic-pill--lang-home"
            onClick={() => goAgeSmoker('bm')}
          >
            BM
          </MetallicPillButton>
          <MetallicPillButton
            size="sm"
            type="button"
            className="metallic-pill--lang-home"
            onClick={() => goAgeSmoker('cn')}
          >
            CN
          </MetallicPillButton>
        </div>
      </div>
    </SurveyBackgroundLayout>
  );
}
